export const zh = {
  title: '森林覆盖减少',
  subtitle: '汉森/UMD/谷歌/美国地质调查局/美国国家航空航天局',
  download_data: 'https://storage.googleapis.com/earthenginepartners-hansen/GFC-2024-v1.12/download.html',
  learn_more: 'http://science.sciencemag.org/content/342/6160/850',
  content: [
    {
      label: '功能',
      value: '确定总树木覆盖损失的区域',
    },
    {
      label: '分辨率',
      value: '30 × 30 米',
    },
    {
      label: '地理覆盖范围',
      value: '全球陆地面积（不包括南极洲和其它北极岛屿）。',
    },
    {
      label: '来源',
      value:
        'Hansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available from: earthenginepartners.appspot.com/science-2013-global-forest.',
    },
    {
      label: '更新频率',
      value: '每年',
    },
    {
      label: '内容日期',
      value: '2001-2024',
    },
    {
      label: '注意事项',
      value:
        '在这组数据集中，“林木覆盖”被定义为所有高于5米的植被，而且可能采取一列林冠郁闭度内的自然森林或人工林的形式。“损失”指的是林木覆盖的去除和死亡率，这可能是由于各种因素造成的，包括机械砍伐、火灾、疾病或风暴造成的损失。因此，“损失”并不等同于森林砍伐。\n\n由于研究方法和内容日期的变化，森林覆盖、减少和增加的数据集无法准确地相互比较。因此，无法用森林覆盖减少减去森林覆盖增加来计算“净”减少值，亦不能用 2000 年森林覆盖减去年度森林覆盖减少来获得当前（2000年后）的森林覆盖。\n\n2011-2022 年数据使用更新的方法生成。在对比原来的 2001-2010 年数据和 2011-2022 年更新后的数据的时候应该格外小心。\n\n作者评估了此数据中的伪阳性发生率（错分误差）为 13%，伪阴性发生率（漏分误差）为 12%，不过准确性因生物群落而异，因此在任何特定位置可能更高或更低。该模型往往忽略了小农地貌的干扰因素，导致撒哈拉以南非洲地区数据准确性更低，因为那里此类干扰因素更常见。作者有 75% 的信心认为，流失在所述年份发生，且有 97% 的信心认为，流失在所述年份前后一年内发生。此数据的用户可以通过检查多个年份的均值，消除这种不确定性。请阅读此数据准确性的 博客系列，以了解更多信息。',
    },
    {
      label: '许可证',
      value: 'CC BY 4.0',
    },
  ],
  overview: {
    label: '概览',
    value:
      '在这组数据集中，“林木覆盖”被定义为所有高于5米的植被，而且可能采取一列林冠郁闭度内的自然森林或人工林的形式。“损失”指的是林木覆盖的去除和死亡率，这可能是由于各种因素造成的，包括机械砍伐、火灾、疾病或风暴造成的损失。因此，“损失”并不等同于森林砍伐。\n\n由于研究方法和内容日期的变化，森林覆盖、减少和增加的数据集无法准确地相互比较。因此，无法用森林覆盖减少减去森林覆盖增加来计算“净”减少值，亦不能用 2000 年森林覆盖减去年度森林覆盖减少来获得当前（2000年后）的森林覆盖。\n\n2011-2024 年数据使用更新的方法生成。在对比原来的 2001-2010 年数据和 2011-2024 年更新后的数据的时候应该格外小心。\n\n在原始出版物中，作者评估了该数据中假阳性（错分误差）的总体发生率为 13%，而假阴性（漏分误差）的发生率为 12%，但准确度因生物群落而异，因此在某一特定位置可能更高，也可能更低。该模型常遗漏小农生产者地貌的干扰，因而导致数据在撒哈拉以南的非洲地区准确度降低，在该地区，此干扰项更为常见。作者有 75% 的把握认为损失发生在所述年份内，有 97% 的把握认为损失发生在所述年份之前或之后的一年。数据用户可研究多年平均值，从而消除此类不确定性。参阅我们关于此数据准确度的系列博客了解更多信息。',
  },
  citation: {
    label: '引用',
    value:
      'Use the following credit when these data are displayed:\nSource: Hansen/UMD/Google/USGS/NASA, accessed through Global Forest Watch\n\nUse the following credit when these data are cited:\nHansen, M. C., P. V. Potapov, R. Moore, M. Hancher, S. A. Turubanova, A. Tyukavina, D. Thau, S. V. Stehman, S. J. Goetz, T. R. Loveland, A. Kommareddy, A. Egorov, L. Chini, C. O. Justice, and J. R. G. Townshend. 2013. “High-Resolution Global Maps of 21st-Century Forest Cover Change.” Science 342 (15 November): 850–53. Data available on-line from:http://earthenginepartners.appspot.com/science-2013-global-forest. Accessed through Global Forest Watch on 28/01/2025. www.globalforestwatch.org',
  },
};
